import { render } from "./TablaSolicitudesPendientes.vue?vue&type=template&id=7cd26ae3"
import script from "./TablaSolicitudesPendientes.vue?vue&type=script&lang=js"
export * from "./TablaSolicitudesPendientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__